import React, { Suspense, lazy } from 'react';
import './App.css';
import './styles/animations.css';

// Lazy load components for better performance
const PUIUXQRGenerator = lazy(() => import('./components/Enhanced/EnhancedQRGenerator'));
const SmartQRView = lazy(() => import('./pages/SmartQRView'));

// Loading component
const LoadingSpinner = () => (
  <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-gray-50 via-white to-gray-100">
    <div className="text-center">
      <div className="inline-flex items-center justify-center w-20 h-20 bg-gradient-to-r from-gray-800 to-black rounded-2xl mb-4 relative overflow-hidden shadow-2xl animate-pulse">
        <div className="absolute inset-0 bg-gradient-to-br from-gray-700 via-gray-800 to-black opacity-90"></div>
        <div className="relative z-10 text-white font-bold text-xl tracking-wider">PUIUX</div>
      </div>
      <p className="text-gray-600 animate-pulse">Loading...</p>
    </div>
  </div>
);

// Error boundary component
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('Error caught by boundary:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-gray-50 via-white to-gray-100 p-4">
          <div className="bg-white rounded-3xl shadow-2xl p-8 max-w-md text-center">
            <div className="text-red-500 mb-4">
              <svg className="w-16 h-16 mx-auto" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
            </div>
            <h2 className="text-2xl font-bold text-gray-800 mb-2">Oops! Something went wrong</h2>
            <p className="text-gray-600 mb-6">We apologize for the inconvenience. Please refresh the page to try again.</p>
            <button
              onClick={() => window.location.reload()}
              className="px-6 py-3 bg-gradient-to-r from-gray-800 to-black text-white rounded-xl hover:from-gray-700 hover:to-gray-900 transition-all duration-200 font-medium"
            >
              Refresh Page
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

// Main App component
function App() {
  // Simple routing based on pathname
  const pathname = window.location.pathname;
  const isSmartQRView = pathname.startsWith('/qr/');
  
  return (
    <ErrorBoundary>
      <Suspense fallback={<LoadingSpinner />}>
        <div className="App">
          {isSmartQRView ? <SmartQRView /> : <PUIUXQRGenerator />}
        </div>
      </Suspense>
    </ErrorBoundary>
  );
}

export default App;